<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                <v-icon class="mr-2">mdi-printer</v-icon>
                Print
              </v-btn>
              <v-btn color="success" class="button-shadow" to="/deposit/list">
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="12" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width: 100px;"><img v-if="logo!=null" :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td style="width:40%; padding-left: 20px;">
                        <p style="margin-top: 0;margin-bottom: 0;"><span style="white-space: pre; font-size: 10pt; text-alignment: left;">{{ companyaddress }}</span></p>
                      </td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Deposit Num</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.depositnum }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Deposit Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ new Date(initvalue.depositdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Reference</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.refnum }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                  </table>
                  <table style="width: 100%">
                  <tr>
                      <td><div align="center"><h3 class="ma-0"><b>{{ `${initvalue.deposittype} Receipt` }}</b></h3></div></td>
                    </tr>
                  </table>
                </v-row>
                <v-row class="mb-5 greyBold--text" cols="12">
                  <v-col cols="12">
                  
                  </v-col>
                </v-row>
                <v-row class="mb-5 greyBold--text">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;" cellpadding="0" cellspacing="0">
                    <tr>
                      <td style="width: 35%; vertical-align: text-top">
                        <div>
                          <span style="font-size: 11pt; font-weight: bold">Vendor</span>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.depositname }}</p>
                        </div>
                      </td>
                      <td>&nbsp;&nbsp;</td>
                      <td style="width: 45%; text-align: right; vertical-align: text-top">
                        <table  style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Deposit Type</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ initvalue.deposittype }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Location</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  locations.length>0 && initvalue.locationid ? locations.find(location=>location._id == initvalue.locationid)['locationcode'] : '' }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Department</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  departments.length>0 && initvalue.departmentid ? departments.find(department=>department._id == initvalue.departmentid)['departmentname'] : '' }}</span></td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <div>&nbsp;&nbsp;</div>
                </v-row>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="5%">#</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="15%">Date</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="15%">Account</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Description</th>
                      <th style="text-align: right; border-bottom: 1px; border-bottom-style: solid" width="30%">Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trans, index) in transactions"  v-bind:key="trans._id">
                          <td>{{ index + 1 }}.&nbsp;</td>
                          <td>{{ new Date(trans.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</td>
                          <td>{{ accounts.length>0 ? accounts.find(account=>account._id==trans.accountid)['accountcode'] : '' }}</td>
                          <td>{{ trans.itemdesc }}</td>
                          <td style="text-align: right">{{ trans.itemamount.toFixed(2) }}</td>
                        </tr>
                        <tr><td colspan="5" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
                        <tr>
                          <td colspan="4" style="vertical-align: top;"><strong>Note: </strong>{{ initvalue.depositnote }}</td>
                          <td colspan="1" style="vertical-align: top;">
                            <table width=100%>
                              <tr>
                                <td colspan="1"><span style="font-size: 11pt; font-weight: bold">Total: </span></td>
                                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.deposittotal.toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.primaryCurrency }}</span></td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import { getLogo, sortDataAsc } from '../../../util/tools';
export default {
  name: 'PrintPage',
  data(){
    return {
      initvalue: {},
      logo: null,
      isTrade: false,
      companyaddress: '',
      transactions: [],
    };
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Department', ['departments']),
    ...mapState('Location', ['locations']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('Department', ['getDepartmentsRequest']),
    ...mapActions('Deposit', ['getDepositRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('SystemSetting', ['getSetting']),
    ...mapActions('User', ['getUsersRequest']),
    PrintElement(divid) {
      var content = document.getElementById(divid).innerHTML;
      var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

      mywindow.document.write('<html><head><title>' + `${this.initvalue.deposittype} Receipt ${this.initvalue.depositnum}` +'</title>');
      mywindow.document.write('</head><body onclick="window.print();">');
      mywindow.document.write(content);
      mywindow.document.write('</body></html>');

      mywindow.document.close();
      mywindow.focus()
      mywindow.print();
      return;
    },
  },
  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'DepositList' });

    let result = await this.getDepositRequest(this.initvalue._id);
    this.transactions = Object.assign([], result.transactions);
    this.files = Object.assign([], result.files);
    this.images = Object.assign([], result.images);

    sortDataAsc(this.transactions, 'transdate');
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.departments.length==0) await this.getDepartmentsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();

    this.logo = getLogo(this.initvalue.companyid);
    this.companyaddress = await this.getSetting({code: 'CompanySettings', name: 'CompanyAddress'}, );
  },
};
</script>

<style src="./Print.scss" lang="scss" scoped />
